<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
/* Add any global styles you need here */

/* Ensure the app container fills the entire screen */
#app {
  height: 100%;
  width: 100%;
  background: none; /* Remove any default background color */
}

/* Set the body and html to full height to display the background properly */
html,
body {
  height: 100%;
  margin: 0;
}
</style>
